import { createSlice, PayloadAction } from '@reduxjs/toolkit'

export interface WorkspaceTab {
  id: string
  title: string
  path: string
  componentKey: string
}

export interface WorkspaceState {
  tabs: WorkspaceTab[]
  activeTabId: string | null
}

const initialState: WorkspaceState = {
  tabs: [],
  activeTabId: null
}

export const workspaceSlice = createSlice({
  name: 'workspace',
  initialState,
  reducers: {
    setTabs(state, action: PayloadAction<WorkspaceTab[]>) {
      state.tabs = action.payload
    },
    setActiveTab(state, action: PayloadAction<string | null>) {
      state.activeTabId = action.payload
    }
  }
})

export const workspaceActions = workspaceSlice.actions
export default workspaceSlice.reducer
